import { apiClient } from '@repo/shared';

const getForPath = async (path) => {
  const url = path ? `/api/images?path=${encodeURIComponent(path)}`: '/api/images';
  const contents = await apiClient.get(url);
  return contents;
};

const createDir = async({path, name}) => {
  const url = path ? `/api/dir?path=${encodeURIComponent(path)}`: '/api/dir';
  console.log('posting to', url);
  
  const contents = await apiClient.post(url, {name});
  return contents;
};

const deleteFile = async({path, filename}) => {
  const url = `/api/images?path=${encodeURIComponent(path)}&filename=${encodeURIComponent(filename)}`;
  console.log('deleting to', url);
  
  const contents = await apiClient.delete(url);
  return contents;
};

const downloadZip = async({path}) => {
  const url = path ? `/api/images/download?path=${encodeURIComponent(path)}`: '/api/images/download';
  console.log('getting to', url);
  
  const contents = await apiClient.get(url);
  return contents;
};

const upload = ({file, toFolder}, onUploadProgress) => {
  return apiClient.uploadFile(`/api/images?path=${encodeURIComponent(toFolder)}`, file);
};

const ImageService = {
  getForPath,
  createDir,
  upload,
  downloadZip,
  deleteFile,
};

export default ImageService;